<template>
  <div>
    <van-popup v-model="show" position="right" style="width:100%;height:100%;">
      <div class="bg-white popup-box">
        <section class="container-footer">
          <div class="popup-del flex all-c" >
            <span class="icon icon-chacha f18" @click="show=false"></span><span class="flex-1 txt-c f20 pr16">选择面试时间</span>
          </div>
          <div class="home-per">
            <div class="ds-partime-list flex f-wrap">
                  <p class="van-bor1 van-hairline--surround"
                     :class="{'selected':timeSysNoList.indexOf(item.label)>-1}"
                     v-for="(item,index) in timeList" :key="index"
                     @click="onCheck(item.label,'timeSysNoList');onCheck(item.weekday,'weekdayList');">
                    <span class="block txt-elips">{{item.label}}</span>
                  </p>
                </div>
          </div>
        </section>
        <footer class="footer-fixed flex all-c">
          <van-button block type="default" class="flex-1 radius-0" @click="clear">
            <span class="f16 c-orange">重置</span>
          </van-button>
          <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="search">
            <span class="f16">确定</span>
          </van-button>
        </footer>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { getInterviewDateFilter } from '../../../libs/util';

  export default {
    data() {
      return {
        show: false,
        showFilter: false,
        activeNames: ['0', '1', '2', '3', '4', '5', '6'],
        tagClassNameList: [],
        timeSysNoList: [],
        weekdayList: [],
        timeList: []
      };
    },
    mounted() {
      this.timeList = getInterviewDateFilter();
    },
    methods: {
      onCheck(item, key) {
        const index = this[key].indexOf(item);
        if (index > -1) {
          this[key].splice(index, 1);
        } else {
          this[key].push(item);
        }
      },
      clear() {
        this.timeSysNoList = [];
        this.weekdayList = [];
      },
      search() {
        let showInterviewTimeStr = '';
        for (let index = 0; index < this.timeList.length; index++) {
          // console.log(this.timeList[index].label);
          if (this.timeSysNoList.indexOf(this.timeList[index].label) >= 0) {
            showInterviewTimeStr += this.timeList[index].label + ',';
          }
        }
        if (showInterviewTimeStr.length > 0) {
          showInterviewTimeStr = showInterviewTimeStr.substring(0, showInterviewTimeStr.length - 1);
          if (showInterviewTimeStr.indexOf('今天') >= 0) {
            if (showInterviewTimeStr.length > 5) {
              showInterviewTimeStr = showInterviewTimeStr.substring(0, 5) + '..';
            }
          } else if (showInterviewTimeStr.indexOf('明天') >= 0) {
            if (showInterviewTimeStr.length > 5) {
              showInterviewTimeStr = showInterviewTimeStr.substring(0, 5) + '..';
            }
          } else {
            if (showInterviewTimeStr.length > 5) {
              showInterviewTimeStr = showInterviewTimeStr.substring(0, 5) + '..';
            }
          }
        }
        // var findVal = this.timeList.find(item => {
        //     return (item.RecruitSysNo * 1) === (this.$store.state.recruit.RecruitSysNo * 1);
        // });
        // console.log(JSON.stringify(this.timeList));
        // console.log(JSON.stringify(this.timeSysNoList));
        console.log(showInterviewTimeStr);
        this.$emit('search', {
          WeekDayList: this.weekdayList,
          ShowInterviewTimeStr: showInterviewTimeStr
        });
        this.show = false;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/css/theme.less';
  .popup-del{ padding: 10px 0 5px 15px;}
  .drawline {
    height: 1px;
    width: 100%;
  }

  .ds-partime-list {
    margin: 30px 20px;
  }
  .ds-partime-list p{
    width: 32%;
    margin: 0 2% 10px 0;
    box-sizing: border-box;
    height:35px;
    line-height:36px;
    font-size: 14px;
  }
  .ds-partime-list p:nth-child(3n+3){
    margin: 0;
  }

  .fringe /deep/.van-cell__value--alone {
    color: #666;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }
</style>
